function input_box(){
  document.addEventListener('keyup', function(e){
    if(e.target.matches('.docapp-coupon-input input[type=text].docapp-coupon-input--input')){
      if(e.target.value != ''){
        document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.add('active-input');
      }else{
        document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.remove('active-input');
      }
    }
  });
  document.addEventListener('focus', function(e){
    if(e.target.matches('.docapp-coupon-input input[type=text].docapp-coupon-input--input')){
      document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.add('active-focus');
    }
  }, true);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (document.body.classList.contains('open-drawer')){
        let inputAvailable = document.querySelector('.docapp-coupon-input input[type=text].docapp-coupon-input--input');
        if(inputAvailable){
          inputAvailable.addEventListener('keyup', handleKeyUp);
          inputAvailable.addEventListener('focus', handleFocus);
          observer.disconnect();
        }
      }
    });
  });
  function handleKeyUp(e){
    if(e.target.value != ''){
      document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.add('active-input');
    }else{
      document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.remove('active-input');
    }
  }
  function handleFocus(e){
    document.querySelector('.docapp-coupon-input .docapp-coupon-input--input-container').classList.add('active-focus');
  }
  observer.observe(document.body, { attributes: true, childList: true, subtree: true });
  if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
    menuBurger.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      document.body.classList.toggle('open-menu');
      document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');    
    });
  });
}
function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
      updateItem(new_line, new_qty);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(centerQtyInput.value);
      if(currentQty > 0){
        centerQtyInput.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        updateItem(newLine, newQty);
      }
    });
  });
  document.querySelectorAll('.cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.item-row').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.item-row').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.item-row').querySelector('.cart_qty').value;
      let formData = {
        'items': [{'id': changevar_id,'quantity': item_current_qty}]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        setTimeout(function(e){
          updateItem(currentid,0);
        },500);
      })
      .catch((error) => {
        console.error('error',error);
        cart_error.text(e.responseJSON.description);
        setTimeout(function(){
          cart_error.text('');
        },2000);
      });
    })
  })
  if(document.querySelectorAll(".cd_variant_cls")) document.querySelectorAll(".cd_variant_cls").forEach((variantBox) => {
    let btn = variantBox.querySelector(".cd_variantbtn");
    if(btn) btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelectorAll('.item-row').forEach((variantBoxRm) => {
        variantBoxRm.querySelector(".cd_variant_cls").classList.remove("active");
      });
      variantBox.classList.add("active");
    });
  });
  if(document.querySelectorAll(".cd-varinat-close,.variant-overlay-box")) document.querySelectorAll(".cd-varinat-close,.variant-overlay-box").forEach((variantBoxClose) => {
    variantBoxClose.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      variantBoxClose.closest('.cart-sidebar').querySelector('.cd_variant_cls.active').classList.remove("active");
    });
  });

  if(document.querySelectorAll('.gift-product li .ellipse-icon')) document.querySelectorAll('.gift-product li .ellipse-icon').forEach((ellipse) => {
    ellipse.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelectorAll('.gift-product li').forEach((ellipserm) => {
        ellipserm.querySelector('.gp-left').classList.remove('active-tooltip');
      });
      ellipse.closest('.gp-left').classList.add('active-tooltip');
    });
  });
  if(document.querySelectorAll('.gift-product li .tooltip p a')) document.querySelectorAll('.gift-product li .tooltip p a').forEach((ellipse_close) => {
    ellipse_close.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      ellipse_close.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  document.body.addEventListener('click', function () {
    document.querySelectorAll('.gift-product li .tooltip').forEach(function (tooltip){
      tooltip.closest('.gp-left').classList.remove('active-tooltip');
    });
  });
  announcebar({
    container: '.product-usps',
    duration: 3000
  });
  quickAddButton();
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.body.classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  document.querySelectorAll(".item-list .item-row").forEach((cItem) => {
    const id = cItem.dataset.id;
    document.querySelectorAll(".gift-product input").forEach((input) => {
      if(input.value === id){
        input.checked = true;
        togglePriceVisibility(input, true);
      }
    });
  });
  document.querySelectorAll(".gift-product input").forEach((input) => {
    input.addEventListener("change", function(e){
      if(input.checked){
        addItemNew(input.value);
        togglePriceVisibility(input, true);
      }else{
        updateItem(input.value,0);
        togglePriceVisibility(input, false);
      }
    });
  });
  function addItemNew(line){
    const data = {
      items:[{id: line,quantity: 1,},],
    };
    fetch("/cart/add.js",{
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => response.json())
    .then(() => {
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
  if(document.querySelector('.add_discount')) document.querySelector('.add_discount').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.cd-discount-wrapper').classList.add('active-discount');
  });
}
// Helper function to get price element for gift products
function getPriceElementForInput(input) {
  // Try multiple strategies to find the price element
  const listItem = input.closest('li');
  if (!listItem) return null;
  // Primary selector
  let priceElement = listItem.querySelector('.gp-rgt');
  return priceElement;
}
// Helper function to toggle gift products price visibility
function togglePriceVisibility(input, show) {
  const priceElement = getPriceElementForInput(input);
  if (priceElement) {
    priceElement.style.display = show ? 'block' : 'none';
  } else {
    console.warn('Price element not found for input');
  }
}

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => updateItem(data_line,0));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector('body').classList.toggle('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        input_box();
      });
    });
    function overlay(){
      document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
        cartButton.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          const createdUlElements = document.querySelectorAll('.wpp-meta-ul');
          createdUlElements.forEach(ul => ul.remove());
          if(document.querySelector('body').classList.contains('open-quick-buy') && document.querySelector('body').classList.contains('open-drawer')){
            document.querySelector('body').classList.remove('open-quick-buy','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }else{
            document.querySelector('body').classList.remove('open-quick-buy','open-drawer','open-menu','open-search','open-sort','open-filter','open-mobile-search','filter-sticky','active-wishli-pro','open-size-chart');
          }
          document.querySelector('localization-form').classList.remove('active');
        });
      });
    }
    function singleCartDrawerClose() {
      const cartDrawerCloseButtons = document.querySelectorAll('.cart-drawer-close');
      if (cartDrawerCloseButtons.length > 0) {
        cartDrawerCloseButtons.forEach((cartDrawerClose) => {
          cartDrawerClose.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const body = document.querySelector('body');
            body.classList.remove(
              'open-quick-buy',
              'open-drawer',
              'open-menu',
              'open-search',
              'open-sort',
              'open-filter',
              'open-mobile-search',
              'filter-sticky',
              'active-wishli-pro',
              'open-size-chart'
            );
            const localizationForm = document.querySelector('localization-form');
            if (localizationForm) {
              localizationForm.classList.remove('active');
            }
          });
        });
      }
    }
    if(window.innerWidth <= 991){
      if(document.querySelector('.section-contradirectional-slider') == null) overlay();
      singleCartDrawerClose();
      if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
        menuBurger.addEventListener('click',function(e){
          e.preventDefault();
          e.stopImmediatePropagation();
          document.body.classList.toggle('open-menu');
          document.body.classList.remove('open-drawer','open-search','open-sort','open-filter', 'active-wishli-pro');    
        });
      });
    }else{
      overlay();
    }
    cartVariant();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      document.querySelector('.cartlist').setAttribute('data-count',cart_count);
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
